import * as yup from "yup";

export const ContactUsValidation = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().required(),
  message: yup.string().required(),
});

export const NewsletterValidation = yup.object().shape({
  email: yup.string().email().required(),
});
